import { useBreadcrumb } from "features/breadcrumbs";
import ListaParceiros from "./components/ListaParceiros";
import Container from "components/Container";

function ParceirosListaPage() {
  useBreadcrumb([{ name: "Administração" }, { name: "Parceiros" }]);
  return (
    <Container>
      <ListaParceiros />
    </Container>
  );
}

export default ParceirosListaPage;
